import type React from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useParams} from "react-router-dom";

import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePlaylist} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";
import {auth} from "~/firebase/firebase";

import useModal from "../../../../hooks/useModal";
import DeletePlaylistContent from "./DeletePlaylistContent";

const DeletePlaylistModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();
  const {playlistId} = useParams<{playlistId: string}>();
  const {data: playlistData} = usePlaylist({id: playlistId});
  const [myUser] = useAuthState(auth);

  if (
    !playlistData ||
    !myUser ||
    playlistData.creatorId !== myUser.uid ||
    playlistData.isImmutable
  )
    return null;

  return (
    <>
      <CustomButton
        onClick={openModal}
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
        title="Delete Playlist"
      >
        <FontAwesomeIcon
          icon={faTrash}
          size="xl"
          className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-red-600 via-red-500 to-black"
        />
      </CustomButton>
      <Modal>
        <DeletePlaylistContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default DeletePlaylistModalButton;
